/** Backend captcha expired (module 09 + code 012 from developer-authentication) */
const CAPTCHA_EXPIRED_ERROR_CODE = "E09012";

module.exports = {
    CAPTCHA_EXPIRED_ERROR_CODE,
    VALIDATION_MESSAGE: {
        APP_URL_VALIDATION_FAIL: "Something went wrong with Domain name and Release URL validation",
        DOMAIN_RELEASE_MISMATCH: "Domain URL and Release URL doesn't match",
    },
    VALIDATION_REGEX: {
        APP_URL_VALIDATION: "Application URL validation failed"
    },
    CHECK_YOUR_EMAIL_MESSAGE: "A password reset link has been sent to your email if it is is registered with us. Please use the link in the mail to reset your password.",
}